// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2r4f6","imageUploader":"EGiftCard_imageUploader__3vTg3"};